import Error from "../../../icons/Error.svg"
import Info from "../../../icons/Informative.svg"
import Success from "../../../icons/Sucess.svg"
import Warn from "../../../icons/Warning.svg"

export const ErrorTemplate = (props) => {
    return (
        <div className="toast-container">
            <img src={Error} alt="" className="toast-icon"/>
            <div className="toast-content-container">
                <span className="toast-summary keduall-typography text-16-semibold-600 text-default-txt">{props.message.summary}</span>
                <div className="toast-message keduall-typography text-14-normal-400 text-default-txt white-space-break-space">{props.message.detail}</div>
            </div>
        </div>
    )
}

export const InfoTemplate = (props) => {
    return (
        <div className="toast-container">
            <img src={Info} alt="" className="toast-icon"/>
            <div className="toast-content-container">
                <span className="toast-summary keduall-typography text-16-semibold-600 text-default-txt">{props.message.summary}</span>
                <div className="toast-message keduall-typography text-14-normal-400 text-default-txt white-space-break-space">{props.message.detail}</div>
            </div>
        </div>
    )
}

export const SuccessTemplate = (props) => {
    return (
        <div className="toast-container">
            <img src={Success} alt="" className="toast-icon"/>
            <div className="toast-content-container">
                <span className="toast-summary keduall-typography text-16-semibold-600 text-default-txt">{props.message.summary}</span>
                <div className="toast-message keduall-typography text-14-normal-400 text-default-txt white-space-break-space">{props.message.detail}</div>
            </div>
        </div>
    )
}

export const WarnTemplate = (props) => {
    return (
        <div className="toast-container">
            <img src={Warn} alt="" className="toast-icon"/>
            <div className="toast-content-container">
                <span className="toast-summary keduall-typography text-16-semibold-600 text-default-txt">{props.message.summary}</span>
                <div className="toast-message keduall-typography text-14-normal-400 text-default-txt white-space-break-space">{props.message.detail}</div>
            </div>
        </div>
    )
}
